import axios from 'axios';
import { API } from './api';

export const updateSessionDevice = async () => {
  try {
    await axios.post(`${API}/admin/update-session-device`, {
      user_agent: navigator.userAgent
    }, {
      headers: { Authorization: `Bearer ${localStorage.getItem('token')}` }
    });
  } catch (error) {
    // Silent failure
    console.debug('Device tracking failed:', error);
  }
};
